// India state codes as prefix of a GSTIN (first 2 characters).
// Source: GST portal official state-code list.
export const GST_STATE_CODES = {
  "01": "Jammu & Kashmir", "02": "Himachal Pradesh", "03": "Punjab",
  "04": "Chandigarh", "05": "Uttarakhand", "06": "Haryana",
  "07": "Delhi", "08": "Rajasthan", "09": "Uttar Pradesh",
  "10": "Bihar", "11": "Sikkim", "12": "Arunachal Pradesh",
  "13": "Nagaland", "14": "Manipur", "15": "Mizoram",
  "16": "Tripura", "17": "Meghalaya", "18": "Assam",
  "19": "West Bengal", "20": "Jharkhand", "21": "Odisha",
  "22": "Chhattisgarh", "23": "Madhya Pradesh", "24": "Gujarat",
  "25": "Daman & Diu", "26": "Dadra & Nagar Haveli & Daman & Diu",
  "27": "Maharashtra", "28": "Andhra Pradesh (old)", "29": "Karnataka",
  "30": "Goa", "31": "Lakshadweep", "32": "Kerala",
  "33": "Tamil Nadu", "34": "Puducherry", "35": "Andaman & Nicobar",
  "36": "Telangana", "37": "Andhra Pradesh", "38": "Ladakh",
  "97": "Other Territory", "99": "Centre",
};

const GSTIN_RE = /^([0-9]{2})([A-Z]{5}[0-9]{4}[A-Z])([0-9A-Z])Z([0-9A-Z])$/i;
const CHECK_ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/**
 * Parse a GSTIN. Returns { valid, state, state_code, pan, entity_code, checksum, checksum_ok, formatted, reason }.
 * Purely client-side — no network call. Verifies the standard GSTIN checksum digit.
 */
export function parseGSTIN(raw) {
  const cleaned = String(raw || "").toUpperCase().replace(/\s+/g, "");
  const m = cleaned.match(GSTIN_RE);
  if (!m) {
    return {
      valid: false,
      state: null,
      state_code: cleaned.slice(0, 2) || null,
      pan: null,
      entity_code: null,
      checksum: null,
      checksum_ok: false,
      formatted: cleaned,
      reason: cleaned.length === 0 ? "empty" : cleaned.length !== 15 ? `${cleaned.length}/15 chars` : "invalid format",
    };
  }
  const [, stateCode, pan, entityCode, checksum] = m;
  const state = GST_STATE_CODES[stateCode] || null;

  // Standard GSTIN checksum: sum of (value(char) * factor) where factor alternates
  // 1 and 2, starting with 1 for the rightmost 14-char prefix. Then check-digit
  // = (36 - (sum % 36)) % 36 mapped back to CHECK_ALPHABET.
  const prefix14 = cleaned.slice(0, 14);
  let sum = 0;
  for (let i = 0; i < 14; i++) {
    const ch = prefix14[i];
    const v = CHECK_ALPHABET.indexOf(ch);
    if (v < 0) return { valid: false, reason: "unknown character", state, state_code: stateCode, pan, entity_code: entityCode, checksum, checksum_ok: false, formatted: cleaned };
    const factor = (i % 2 === 0) ? 1 : 2;
    const prod = v * factor;
    sum += Math.floor(prod / 36) + (prod % 36);
  }
  const expected = (36 - (sum % 36)) % 36;
  const expectedChar = CHECK_ALPHABET[expected];
  const checksum_ok = expectedChar === checksum;
  return {
    valid: !!state && checksum_ok,
    state,
    state_code: stateCode,
    pan,
    entity_code: entityCode,
    checksum,
    checksum_ok,
    formatted: cleaned,
    reason: !state ? "unknown state code" : (!checksum_ok ? "checksum mismatch — please recheck" : "ok"),
  };
}
